module.exports = __webpack_public_path__ + "img/revision_carro_resize.64d1baeb.png";